module.exports = __webpack_public_path__ + "static/media/eight_monkeys.8dc3cd11.gif";